import { getSupervision } from './getSupervision';
import { sendSupervisionValidationEmails } from '../../../supervisions/utils/sendSupervisionValidationEmails';
import { createSupervisionInvoices } from '../../../supervisions/ShowSupervision/utils/createSupervisionInvoices';

export const patchSupervisionStatus = async ({
  status,
  pensioners,
  dispatchAPI,
  supervision,
  message,
  setSupervision,
  setIsLoading,
  id,
  t
}) => {
  try {
    await dispatchAPI('PATCH', {
      url: `/supervisions/${id}/status`,
      body: status
    });

    await sendSupervisionValidationEmails({
      supervision,
      dispatchAPI,
      message,
      t
    });

    await getSupervision({
      dispatchAPI,
      id,
      setSupervision,
      message,
      setIsLoading
    });

    const updatePromises = pensioners.map(async (pensioner) => {
      await dispatchAPI('PATCH', {
        url: `pensioners/${pensioner._id}`,
        body: { is_in_supervision: true }
      });
    });

    await Promise.all(updatePromises);

    createSupervisionInvoices({ supervision, dispatchAPI, message });
  } catch (e) {
    message(e);
  }
};
